import Tooltip from '@mui/material/Tooltip';
import Typography, { type TypographyProps } from '@mui/material/Typography';
import { useRef, useState } from 'react';

/**
 * One line of text that ends in "…" when it doesn't fit, and then shows the full text
 * in a tooltip when you point at it (only then: text that fits gets no tooltip).
 * Use it wherever text is cut short: names, organisations, emails, addresses.
 */
export function TruncatedText({ text, ...props }: { text: string } & Omit<TypographyProps, 'children' | 'noWrap'>) {
  const ref = useRef<HTMLElement>(null);
  const [cut, setCut] = useState(false);
  const measure = () => {
    const el = ref.current;
    setCut(!!el && el.scrollWidth > el.clientWidth + 1);
  };
  return (
    <Tooltip title={cut ? text : ''} placement="top-start" enterDelay={300} disableInteractive>
      <Typography ref={ref} noWrap onMouseEnter={measure} onFocus={measure} {...props}>
        {text}
      </Typography>
    </Tooltip>
  );
}
